import { useQuery } from '@tanstack/react-query';

import { UnitService } from '../services/unit';

export function useGetUnits(levelPosition: number, unitPosition: number) {
  const { data, error, isFetching, isLoading, isError } = useQuery(
    ['getUnits', { levelPosition, unitPosition }],
    () => UnitService.getUnitWithLessons(levelPosition, unitPosition),
  );

  return {
    units: data?.data,
    error,
    isFetching,
    isLoading,
    isError,
  };
}
